
import { Image, Checkbox, Button, message, List, Tooltip } from 'antd'
import { useEffect, useState } from 'react'
import { downloadFile, getFileUrl } from '@/utils/FileUtil';
import './imageDownload.css';

const ImageDownload = ({ files }) => {

    const [messageApi, contextHolder] = message.useMessage();
    const [selectedValues, setSelectedValues] = useState([]);

    const [fileInfos, setFileInfos] = useState([]);

    useEffect(() => {
        parseFileUrls();
    }, [files])

    const parseFileUrls = async () => {
        let infos = JSON.parse(JSON.stringify(files || []))
        if (!infos) {
            return
        }
        for (let info of infos) {
            for (let file of info.value || []) {
                file.downloadUrl = await getFileUrl(file.filePath)
            }
        }
        setFileInfos(infos)
    }

    const checkAll = () => {
        let allFiles = []
        for (const info of fileInfos) {
            if (info.value) {
                allFiles.push(...info.value)
            }
        }
        if (selectedValues.length === allFiles.length) {
            setSelectedValues(() => [])
        } else {
            setSelectedValues(allFiles)
        }
    }
    const handleChange = (values) => {
        setSelectedValues(values);
    };

    const download = () => {
        if (!selectedValues.length) {
            messageApi.error("请选择要下载的图片")
            return
        }
        for (const file of selectedValues) {
            try {
                downloadFile(file.downloadUrl, file.fileName)
            } catch (e) {
                messageApi.error("下载图片失败：" + e.message)
            }
        }
    };

    return (
        <div className="image-download-container">
            {contextHolder}
            <div className="image-download-toolbar">
                <Button onClick={checkAll}>全选/取消</Button>
                <Button type='primary' className="download-button" disabled={selectedValues.length <= 0} onClick={download}>下载</Button>
                <span className="selected-count">{`选中 ${selectedValues.length} 项`}</span>
            </div>
            <div className="image-list-container">
                <Checkbox.Group onChange={handleChange} value={selectedValues} className="checkbox-group">
                    {fileInfos.map(infos => (
                        <div key={infos.key} className="file-category">
                            <div className={infos.value ? "category-title" : "category-title hidden"}>{infos.key}</div>
                            <List
                                grid={{ gutter: 16, column: 5, xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 5 }}
                                dataSource={infos.value || []}
                                renderItem={file => {
                                    return (
                                        <List.Item className="image-item">
                                            <div className="image-wrapper">
                                                <Image className='commodity-img' src={file.downloadUrl} />
                                                <Checkbox value={file} className="image-checkbox">
                                                    <Tooltip title={file.fileName}><div style={{
                                                        lineHeight: "1.5em",
                                                        height: "1.5em",
                                                        wordBreak: "break-all",
                                                        overflow: "hidden",
                                                        textOverflow: "clip",
                                                    }}>{file.fileName}</div>
                                                    </Tooltip>
                                                </Checkbox>
                                            </div>
                                        </List.Item>
                                    )
                                }} />
                        </div>
                    ))}
                </Checkbox.Group>
            </div >
        </div >
    );
}
export default ImageDownload;